<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('statistical.boxAddTask.addTask')"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-row
        type="flex"
        justify="start"
        align="top"
      >
        <el-col :span="11">
          <el-form
            ref="form1"
            :model="formInfo"
            :rules="rules"
            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          >
            <el-form-item
              :label="$t('statistical.hisDownloadSearch.missionName') + '：'"
              prop="taskName"
            >
              <el-input
                v-model="formInfo.taskName"
                :placeholder="$t('statistical.hisDownloadSearch.missionName')"
                clearable
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row
        type="flex"
        justify="start"
        align="top"
      >
        <el-col :span="18">
          <el-form
            ref="form2"
            :model="formInfo"
            :rules="rules"
            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          >
            <el-form-item
              :label="$t('statistical.boxAddTask.selectVehicle') + '：'"
              prop="carStr"
            >
            <div style="position:relative;">
                <div class="fl car-tag">
                  <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
                    <el-tag
                      v-for="tag in selectCarList"
                      :key="tag.carid"
                      closable
                      effect="plain"
                      :disable-transitions="false"
                      @close="handleClose(tag)"
                    >
                      <vue-licenseplate
                        :licensepalte="tag.licenseplate"
                        :area="tag.areaName"
                      />
                    </el-tag>
                  </el-scrollbar>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col
          :span="6"
          type="flex"
          justify="center"
          align="center"
        >
          <el-button
            type="primary"
            @click="showTaskList"
          >
            {{ $t('public.create') }}
          </el-button>
          <el-button
            class="dialog-cancel"
            type="primary"
            @click="handleClear"
          >
            {{ $t('public.reset') }}
          </el-button>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="start"
        align="top"
      >
        <el-col :span="22">
          <el-form
            :model="formInfo"
            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          >
            <el-form-item style="color:#999;margin-top: -5px;">
              <span v-if="selectCarNumber>0">{{ this.$t('statistical.boxAddTask.select') }} <span style="color:red">{{ selectCarNumber }}</span> {{ this.$t('statistical.boxAddTask.selectDes') }}</span>
              <span v-else>{{ this.$t('statistical.boxAddTask.carInfo') }}</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        align="top"
      >
        <el-col :span="11">
          <el-form
            ref="form3"
            :model="formInfo"
            :rules="rules"
            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          >
            <el-form-item
              :label="$t('public.startTime') + '：'"
              prop="beginTime"
            >
              <el-date-picker
                v-model="formInfo.beginTime"
                filterable
                clearable
                :placeholder="$t('public.startTime')"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="11">
          <el-form
            ref="form4"
            :model="formInfo"
            :rules="rules"
            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          >
            <el-form-item
              :label="$t('public.endTime') + '：'"
              prop="endTime"
            >
              <el-date-picker
                v-model="formInfo.endTime"
                filterable
                clearable
                :placeholder="$t('public.endTime')"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="center"
        align="top"
      >
        <el-col :span="24">
          <el-form
            ref="form5"
            :rules="rules"
            :model="formInfo"

            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          />
        </el-col>
      </el-row>

      <!-- <el-row
        v-show="selectCarList.length===1"
        type="flex"
        justify="center"
        align="top"
      >
        <el-col :span="24">
          <el-form
            ref="formLeft"
            :model="formInfo"
            :label-position="'right'"
            :label-width="$t('statistical.boxAddTask.tabelWidth')"
          >
            <el-form-item :label="$t('statistical.boxAddTask.selectParameters') + '：'">
              <div style="position:relative;">
                <div
                  style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:999;cursor:pointer"
                  @click="showParams"
                />
                <el-input v-model="paramsStr">
                  <template slot="append">
                    <i class="el-icon-arrow-down" />
                  </template>
                </el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row> -->
    </vue-linetitle>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        class="dialog-cancel"
        type="primary"
        @click="handleCancel"
      >{{ this.$t('public.cancel') }}</el-button>
      <el-button
        type="primary"
        @click="submitForm"
      >{{ this.$t('public.define') }}</el-button>
    </span>
    <!-- 选择车辆 -->
    <select-car-dialog
      :visibles.sync="selectCarVisibles"
      :data="selectCarList"
      @select-complete="selectCarComplete"
    />
    <!-- 导入 -->
    <import-dialog
      ref="importDialog"
      action="api/common/ImportCarInfo"
      :template-url="'file/upload/template/VIN批量查询模版.xlsx'"
      :append-to-body="true"
      :visibles.sync="importVisible"
      @upload-success="importCarComplete"
    />
    <!-- 查看参数 -->
    <params-dialog
      :visibles.sync="paramsVisible"
      :data="selectCarList"
      :default-params="selectParamsList"
      @selcet-complete="selectParams"
    />
  </el-dialog>
</template>

<script>
// 混入
import selectCarDialog from './selectCarDialog'
import importDialog from '@/components/importDialog'
import paramsDialog from './paramsDialog'
import { createTask } from '@/api/vehicletravel/downloadData'
import { mapGetters } from 'vuex'
import { beginTimeAndEndTime, duplicateRemoval } from '@/utils/base'
// request
export default {
  name: 'AddTaskDialog',
  components: { selectCarDialog, importDialog, paramsDialog },
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['commontData']),
    selectCarNumber() {
      return this.selectCarList.length
    },
    // paramsStr() {
    //   return this.selectParamsItemList.map(obj => obj.label).join(',')
    // }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        const myDate = new Date()
        const year = myDate.getFullYear()
        let month = myDate.getMonth()+1 // 得到月份
        let date = myDate.getDate() // 得到日期
        let hour = myDate.getHours() // 得到小时
        let minits = myDate.getMinutes() // 得到分钟
        let second = myDate.getSeconds()
        month = month.toString().padStart(2, '0')
        date = date.toString().padStart(2, '0')
        hour = hour.toString().padStart(2, '0')
        minits = minits.toString().padStart(2, '0')
        second = second.toString().padStart(2, '0')
        const str = this.$store.state.user.userInfo.loginName+`${year}${month}${date}${hour}${minits}${second}`
        this.formInfo.taskName = str
      }
    }
  },
  // created() {
  // },
  data() {
    const validateTask = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(vm.$t('statistical.boxAddTask.error.selectTaskName')))
      }
    }
    const validatecarStr = (rule, value, cb) => {
      if (this.selectCarList.length === 0) {
        return cb(new Error(vm.$t('statistical.boxAddTask.error.selectVehicle')))
      }
    }
    const validatebegintime = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(vm.$t('statistical.boxAddTask.error.selectStartTime')))
      }
    }
    const validateendtime = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(vm.$t('statistical.boxAddTask.error.selectEndTime')))
      }
    }
    // const validatefiletype = (rule, value, cb) => {
    //   if (!value) {
    //     return cb(new Error(this.$t('statistical.boxAddTask.error.selectDownloadType')))
    //   }
    // }
    return {
      formInfo: {
        taskName: ''
      },
      formList: ['form1', 'form2', 'form3', 'form4', 'form5'],
      selectCarList: [],
      selectCarVisibles: false,
      importVisible: false,
      paramsVisible: false,
      selectParamsList: [],
      selectParamsItemList: [],
      rules: {
        taskName: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: validateTask
          }
        ],
        carStr: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: validatecarStr
          }
        ],
        beginTime: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: validatebegintime
          }
        ],
        endTime: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: validateendtime
          }
        ]
      }
    }
  },
  mounted() {},
  methods: {
    handleClose(tag) {
      this.selectCarList.splice(this.selectCarList.indexOf(tag), 1)
      this.$refs.carform.validate((vaild) => {
        if (!vaild) {
          // check2 = false
        }
      })
    },
    // 显示车辆列表
    showTaskList() {
      this.selectCarVisibles = true
    },
    // 显示参数
    showParams() {
      this.paramsVisible = true
    },
    // 选择参数
    selectParams(e) {
      this.selectParamsList = [...e.idList]
      this.selectParamsItemList = [...e.itemList]
    },
    // 选择车辆列表完成
    selectCarComplete(e) {
      this.selectCarList = duplicateRemoval([...e], 'carid')
    },
    // 导入车辆完成
    importCarComplete(e) {
      this.selectCarList = duplicateRemoval(
        [...this.selectCarList, ...e.successList],
        'carid'
      )
      this.$refs.importDialog.closeDialog()
    },
    // 清除
    handleClear() {
      this.selectCarList = []
    },

    // 清空数据
    restData() {
      for (const keys in this.formInfo) {
        this.formInfo[keys] = ''
      }
      this.selectCarList = []
      this.selectParamsList = []
      this.selectParamsItemList = []
    },
    // 关闭dialog
    closeDialog() {
      this.restData()
      this.$emit('update:visibles', false)
    },
    // 点击取消
    handleCancel() {
      this.closeDialog()
    },
    // 提交
    submitForm() {
      let isNext = true
      for (let i = 0; i < this.formList.length; i++) {
        this.$refs[this.formList[i]].validate(valid => {
          if (valid) {
            // isNext = true
          } else {
            isNext = false
          }
        })
      }
      if (!isNext) return
      if (
        !beginTimeAndEndTime({
          beginTime: this.formInfo.beginTime,
          endTime: this.formInfo.endTime,
          message: this.$t('statistical.boxAddTask.error.selectTimes')
        })
      ) {
        return
      }
      const postData = {
        taskname: this.formInfo.taskName,
        carlist: this.selectCarList.map(obj => obj.carid),
        begintime: this.formInfo.beginTime,
        endtime: this.formInfo.endTime,
        filetype: '1'
      }
      // if (this.selectCarList.length === 1) {
      //   postData.fieldlist = this.selectParamsItemList.map(obj => obj.id)
      // }
      createTask(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search_list {
  padding-top: 0;
}
.chepai-border{
  border:1px dashed #ddd;
  height:200px;
  width:100%;
}
.car-tag{
  width: calc(100%);
  height: 100px;
  border: 1px dashed #ddd;
  padding:3px;
  .numberPlate{
    margin:5px 0;
    span{
      font-weight: bold;
    }
  }
  .el-tag{
    background: none;
    color: #333;
    border:0 none;
    height: 55px;
    position: relative;
    padding:5px!important;
    .el-icon-close{
      right: 0;
      position: absolute;
      top: 0px;
      background: #ff0000;
      color: #fff;
    }
    // span{
    //   display:block;
    // }
  }
  .el-tag--small{
    padding:0 2px;
  }
}
</style>
